import React, { useEffect, useState } from "react";
import { Table, Select, Input } from "antd";
import styles from "./Payments.module.css";
import { useNavigate } from "react-router-dom";
import { TextComponent } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { PaymentsMiddleware } from "../../Store/Middlewares/PaymentsMiddleware";
import Pagination from "../../components/Pagination/Pagination";
import moment from "moment/moment";


const Payments = () => {

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const DATA = useSelector(state => state.PaymentsReducer?.payments);
  const DATA_PAGINATION = useSelector(state => state.PaymentsReducer?.paymentsPagination);

  const [currentPage, setCurrentPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(12);

  useEffect(() => {
    getData()
  }, []);

  const getData = (arg) => {
    const data = {
      limit: pageLimit,
      page: 1,
    };
    dispatch(PaymentsMiddleware.onGetPayments(arg || data))
      .then((res) => { })
      .catch((err) => { console.log("Error fetching data:", err) });
  }

  const columns = [
    {
      title: "User Name",
      dataIndex: "username",
      key: "username",
      render: (key,text) => (
        <div className={styles.ingredientCell}>
          <span>{text?.user?.firstName + " " + text?.user?.lastName}</span>
        </div>
      ),
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
       render: (key,text) => (
        <div className={styles.ingredientCell}>
          <span>{text?.user?.email}</span>
        </div>
      ),
    },
    {
      title: "Yardsale",
      dataIndex: "Yardsale",
      key: "Yardsale",
       render: (key,text) => (
        <div className={styles.ingredientCell}>
          <span>{text?.yardSale?.title}</span>
        </div>
      ),
    },
     {
      title: "Discount code",
      dataIndex: "Discount code",
      key: "Discount code",
       render: (key,text) => (
        <div className={styles.ingredientCell}>
          <span>{text?.yardSale?.discountCode ?? "-"}</span>
        </div>
      ),
    },

    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },

    {
      title: "Paid On",
      dataIndex: "date",
      key: "Paid On",
        render: (key,text) => (
        <div className={styles.ingredientCell}>
          <span>{moment(text?.createdAt).format("MMM, DD YYYY")}</span>
        </div>
      ),
    },



  ];

  return (
    <div className={styles.mainCont}>

      <div className={styles.HeadingDiv}>
        <TextComponent
          className={styles.Heading}
          text={"Payments"}
        />
      </div>


      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={DATA}
          pagination={false}
          style={{
            boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 15px 0px'
          }}
        />

        {

          (DATA_PAGINATION?.totalPages > 1) &&
          <Pagination
            currentPage={currentPage}
            totalPages={DATA_PAGINATION?.totalPages}
            nextButton={(e) => {
              getData({
                limit: pageLimit,
                page: currentPage + 1,
              });
              setCurrentPage(currentPage + 1);
            }}
            previousButton={(e) => {
              getData({
                limit: pageLimit,
                page: currentPage - 1,
              });
              setCurrentPage(currentPage - 1);
            }}
          />
        }

      </div>
    </div>
  );
};

export default Payments;
